import flyio from "flyio";
const specialUrls = ['/api/login'];
export function API(url, method, param, sucCallback, finalCallback, errorCallback) {

    flyio.config.baseURL = process.env.VUE_APP_API_URL;
    
    //添加请求拦截器
    flyio.interceptors.request.use((request) => {
        let token = window.localStorage.getItem('token');
        if(specialUrls.indexOf(request.url) == -1){
            if(!token){
                window.localStorage.removeItem('token');
                window.location.href='/login';
            }
            request.headers["Authorization"]=token;
        }
        return request;
    });
    //相应拦截器
    flyio.interceptors.response.use((response) => {
        return response.data;
    });
  
    flyio.request(url,param,{
        method:method,
        timeout:10000
    }).then(function (response) {
        if (sucCallback != undefined && typeof sucCallback == 'function') {
            sucCallback(response);
        }
    }).catch(function (error) {
        console.log(error)
        if (errorCallback != undefined && typeof errorCallback == "function") {
            errorCallback(error.response.data);
        } else {
            if (error.response && error.response.data.message === 'Unauthenticated.') {
                // tipMsg("您的登录会话已过期，请重新登录",'error',function(){
                window.location.href='/login';
                // },1);
            }
        }
    }).finally(function () {
        if (finalCallback != undefined && typeof finalCallback == 'function') {
            finalCallback();
        }
    });
}
